import React, { Component, useEffect, useState } from "react";
import Form from "../../comman/form";
import config from "../../config.json";
import Swal from "sweetalert2";
import Subcontractor from "./AddCandidate/Subcontractor";
import Candidate from "./AddCandidate/Candidate";
import Agency from "./AddCandidate/Agency";
import Msp from "./AddCandidate/Msp";
import Recruiter from "./AddCandidate/Recruiter";
import { useDispatch, useSelector, useStore } from "react-redux";
import {
  candidateBprmFormReceived,
  getCandidateBprmForm,
  getFilterCandidates,
  getSelectedCandidateObj,
  loadCandidateBprmForm,
  loadCandidatesByFilter,
  loadSelectedCandidatesByFilter,
} from "../../app/store/candidate";
import { getFieldData, getFormatedNumber } from "../../services/appService";
import { getAlert } from "../../services/appAlerts";
import _ from "lodash";
import { getCurrentUser } from "../../app/store/auth";
import { getUpdateStatus, updateBprmForm } from "../../app/store/bprmForm";
import { getAllRates, loadAllRates } from "../../app/store/rates";

const AddCandidate = (props) => {
  const {
    selectedObj,
    actType,
    setSelectedTabKey,
    handleAddEditCandidate,
    selectedTabKey,
    setSelectedCandidateId,
    handleGoBack,
    onCandidateSaved,
  } = props;

  const getUpdateStatusData = useSelector(getUpdateStatus);
  const [selObjId, setSelObjId] = useState(null);
  const [rateHistory, setRateHistory] = useState([]);

  const currentUser = getCurrentUser();

  const candidateEntity = [
    { id: 1, name: "C2C Basis" },
    { id: 2, name: "W2 Basis" },
    { id: 3, name: "1099 Basis" },
  ];
  const w2Basis = [
    { id: 1, name: "W2 Hourly with Benefits" },
    { id: 2, name: "W2 Hourly with No-Benefits" },
  ];

  const [entityType, setEntityType] = useState(null);
  const [w2Type, setW2type] = useState(null);
  const [selectedKey, setSelectedKey] = useState("0");
  const [wfTask, setWfTask] = useState(null);
  const [wfId, setWfId] = useState(0);
  const [actionType, setActionType] = useState(actType);
  const [candidateObj, setCandidateObj] = useState(null);
  const [wfForm, setWfForm] = useState(null);
  const [aworkfinityApp, setAworkfinityApp] = useState(null);
  const [compType, setCompType] = useState("");

  const selectedCandidateObjSelector = useSelector(getSelectedCandidateObj);
  const candidateBprmFormSelector = useSelector(getCandidateBprmForm);
  const allRatesSelector = useSelector(getAllRates);

  const dispatch = useDispatch();
  useEffect(() => { }, [selectedTabKey]);

  useEffect(() => {
    if (selectedObj !== "" && actType === "edit") {
      setCandidateObj(selectedObj);
      const entType = getFieldData(
        selectedObj.performerData,
        "candidateonboardingform",
        "CandidateEntity"
      );
      const w9type = getFieldData(
        selectedObj.performerData,
        "candidateonboardingform",
        "w9_Type"
      );
      setEntityType(entType);
      setW2type(w9type);
      dispatch(candidateBprmFormReceived(null));
      setCandidateType(entType);
      setSelectedKey("0");
      dispatch(loadAllRates(selectedObj.performerid));
    } else {
      setEntityType("");
      setW2type(null);
      setWfTask(null);
      setWfId(0);
      setCandidateObj(null);
      setSelectedKey("0");
      dispatch(candidateBprmFormReceived(null));
    }
  }, [selectedObj, selectedTabKey]);

  useEffect(() => {
    if (allRatesSelector) setRateHistory(allRatesSelector);
  }, [allRatesSelector]);

  const handleSelectEntity = ({ currentTarget }) => {
    setEntityType(currentTarget.value);
    setCandidateType(currentTarget.value);
  };

  const setCandidateType = (entType) => {
    let appCiid = 0;
    if (selectedObj?.applications?.length > 0) {
      appCiid = selectedObj?.applications[0].ciid;
      // if (allWfTasks?.length > 0) {
      //   appCiid = allWfTasks[allWfTasks.length - 1].ciid;
      // }
    }

    if (entType === "C2C Basis") {
      setWfTask({ formId: config.formIds.candidate.C2C_Basis, ciid: appCiid });
      setWfId(config.workflowsIds.candidate.C2C_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.C2C_Basis));
    }
    if (entType === "W2 Basis") {
      setWfTask({ formId: config.formIds.candidate.W2_Basis, ciid: appCiid });
      setWfId(config.workflowsIds.candidate.W2_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.W2_Basis));
    }
    if (entType === "1099 Basis") {
      setWfTask({
        formId: config.formIds.candidate.Ten_99_Basis,
        ciid: appCiid,
      });
      setWfId(config.workflowsIds.candidate.Ten_99_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.Ten_99_Basis));
    }
  };

  useEffect(() => {
    console.log(candidateBprmFormSelector);
    setWfForm(candidateBprmFormSelector);
  }, [candidateBprmFormSelector]);

  const activeTabs = [
    { key: "0", label: "Candidate", icon: "fa-user" },
    ...(entityType === "C2C Basis" ? [{ key: "1", label: "Subcontractor", icon: "fa-handshake-o" }] : []),
    { key: "2", label: "Recruiter", icon: "fa-user-plus" },
    { key: "3", label: "Agency/Client", icon: "fa-building" },
    { key: "4", label: "MSP", icon: "fa-cogs" }
  ];

  const getSavedCandidateId = () => candidateObj?.performerid || candidateObj?.id || 0;

  const handleBackToCandidateList = () => {
    if (actType === "edit") {
      handleGoBack();
      return;
    }

    const savedCandidateId = getSavedCandidateId();
    if (savedCandidateId > 0 && onCandidateSaved) {
      onCandidateSaved(savedCandidateId, { goHome: true });
      return;
    }
    handleGoBack();
  };

  useEffect(() => {
    if (!activeTabs.some((tab) => tab.key === selectedKey)) {
      setSelectedKey("0");
    }
  }, [entityType, selectedKey]);

  const setKey = (key) => {
    if (!candidateObj) {
      getAlert("", "Candidate not added", "warning");
      return;
    }
    if (key === "1" && entityType !== "C2C Basis") {
      getAlert("", "Subcontractor is only available for C2C candidates", "warning");
      return;
    }
    setSelectedKey(key);
  };

  const handleNextTab = (btnType) => {
    if (btnType !== "save" && btnType !== "exit") {
      const currentIndex = activeTabs.findIndex((tab) => tab.key === selectedKey);
      const nextTab = activeTabs[currentIndex + 1];
      if (nextTab) setSelectedKey(nextTab.key);
    }
    if (btnType === "exit") {
      handleBackToCandidateList();
    }
  };

  const updateBprmFormData = (selectedObj) => {
    if (aworkfinityApp == null) return;
    let appCiid = 0;
    if (selectedObj?.applications?.length > 0) {
      appCiid = selectedObj?.applications[0].ciid;
    }

    if (appCiid > 0) {
      const disValus = _.uniq(["candidateonboardingform"]);
      const frmData = new FormData();
      frmData.append("appEntity", JSON.stringify(aworkfinityApp));
      frmData.append("ciid", appCiid);
      frmData.append("ddTypes", disValus);

      if (entityType === "C2C Basis")
        frmData.append("formId", config.formIds.candidate.C2C_Basis);
      if (entityType === "W2 Basis")
        frmData.append("formId", config.formIds.candidate.W2_Basis);
      if (entityType === "1099 Basis")
        frmData.append("formId", config.formIds.candidate.Ten_99_Basis);

      frmData.append("performerId", currentUser.id);
      frmData.append("userName", currentUser.name);
      dispatch(updateBprmForm(frmData));
    }
    dispatch(loadAllRates(selectedObj.performerid));
  };

  const updateSelectedObject = async (id, wfData, type) => {
    const frmBody = new FormData();
    frmBody.append("id", id);
    frmBody.append("name", "");
    frmBody.append("email", "");
    frmBody.append("entity", "");
    frmBody.append("type", "candidate");
    frmBody.append("filterType", "single");
    dispatch(loadSelectedCandidatesByFilter(frmBody));
    if (wfData) {
      setAworkfinityApp(wfData);
      setCompType(type);
    }
  };

  useEffect(() => {
    if (getUpdateStatusData) {
      const frmBody = new FormData();
      frmBody.append("id", selObjId || 0);
      frmBody.append("name", "");
      frmBody.append("email", "");
      frmBody.append("entity", "");
      frmBody.append("type", "candidate");
      frmBody.append("filterType", "single");
      if (selObjId) {
        dispatch(loadSelectedCandidatesByFilter(frmBody));
      }
    }
  }, [getUpdateStatusData]);

  useEffect(() => {
    if (selectedCandidateObjSelector.length > 0) {
      const selectedCandidate = selectedCandidateObjSelector[0];
      setCandidateObj(selectedCandidate);
      updateBprmFormData(selectedCandidate);
      setActionType("edit");
      if (onCandidateSaved) {
        onCandidateSaved(selectedCandidate.performerid || selectedCandidate.id, { goHome: false });
      } else {
        handleAddEditCandidate();
      }
    }
  }, [selectedCandidateObjSelector]);

  return (
    <>
      <style>{`
        @keyframes asFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .wf-add-candidate-container {
          border: 1px solid rgba(226, 232, 240, 0.9) !important;
          border-radius: 0 !important;
          background: #ffffff !important;
          box-shadow: none !important;
          margin-top: 10px !important;
          animation: asFadeIn 0.3s ease both !important;
          overflow: hidden !important;
        }

        /* ── Form Header ── */
        .wf-add-candidate-container .as-form-header {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          padding: 16px 22px !important;
          background: #ffffff !important;
          border-bottom: 1.5px solid #e2e8f0 !important;
          position: relative !important;
          overflow: hidden !important;
          margin: 0 !important;
          width: 100% !important;
          border-radius: 0 !important;
        }
        .as-form-header-left {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          min-width: 260px !important;
          flex: 1 1 auto !important;
        }
        .as-selected-context-details {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 6px !important;
          color: #475569 !important;
          font-size: 13px !important;
          font-weight: 400 !important;
          line-height: 1.4 !important;
          margin-top: 5px !important;
        }
        .as-selected-context-separator {
          color: #475569 !important;
        }
        .as-form-header-icon {
          width: 42px !important;
          height: 42px !important;
          border-radius: 0 !important;
          background: #f5f5f5 !important;
          border: 1.5px solid #d4d4d4 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #525252 !important;
          font-size: 17px !important;
          flex-shrink: 0 !important;
          box-shadow: none !important;
        }
        .as-form-header-text {
          position: relative !important;
          z-index: 1 !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: flex-start !important;
        }
        .as-form-header-title {
          color: #0f172a !important;
          font-size: 14.5px !important;
          font-weight: 600 !important;
          margin: 0 !important;
          line-height: 1.2 !important;
        }
        .as-form-header-meta {
          display: flex !important;
          align-items: center !important;
          gap: 7px !important;
          flex-wrap: wrap !important;
          margin: 7px 0 0 !important;
        }
        .as-form-header-right {
          display: flex !important;
          align-items: center !important;
          margin-left: auto !important;
          flex-shrink: 0 !important;
        }
        .as-header-back-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          height: 34px !important;
          min-height: 34px !important;
          padding: 0 14px !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          background: #ffffff !important;
          color: #1e293b !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08) !important;
          cursor: pointer !important;
        }
        .as-header-back-btn:hover {
          background: #f5f5f5 !important;
          border-color: #a3a3a3 !important;
          color: #171717 !important;
        }
        .as-meta-pill {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          padding: 4px 12px !important;
          border-radius: 0 !important;
          background: #ffffff !important;
          border: 1px solid #171717 !important;
          color: #171717 !important;
          font-size: 12px !important;
          font-weight: 700 !important;
          height: auto !important;
          line-height: 1.5 !important;
        }
        .as-meta-pill i {
          color: #171717 !important;
          font-size: 11px !important;
        }

        /* ── Form Body ── */
        .as-form-body {
          padding: 18px 22px !important;
          background: #ffffff !important;
          border-bottom: 1.5px solid #f1f5f9 !important;
        }
        .as-form-body .form-control:disabled,
        .as-form-body .form-control[disabled] {
          background: #f8fafc !important;
          border-color: #dbe3ee !important;
          color: #1e293b !important;
          cursor: not-allowed !important;
          opacity: 1 !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
        }

        .as-form-body .form-control:disabled:focus,
        .as-form-body .form-control[disabled]:focus {
          border-color: #dbe3ee !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          background: #f8fafc !important;
        }

        .as-form-body .wf-input-wrap:has(.form-control:disabled) .wf-input-icon,
        .as-form-body .wf-input-wrap:has(.form-control[disabled]) .wf-input-icon {
          color: #94a3b8 !important;
        }

        /* ── Modern Rich UI Custom Tabs (enhanced like document tab) ── */
        .wf-custom-tabs-container {
          margin-bottom: 24px !important;
          width: 100% !important;
          position: relative !important;
        }
        /* Segmented control, matching the Contract Documents / ACH / Insurance
           chips in ReviewTask: recessed track, active tab lifts out as a pill. */
        .wf-custom-tabs-list {
          list-style: none !important;
          margin: 0 !important;
          padding: 4px !important;
          display: flex !important;
          align-items: center !important;
          gap: 4px !important;
          width: fit-content !important;
          max-width: 100% !important;
          flex-wrap: wrap !important;
          background: #f1f5f9 !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 12px !important;
          position: relative !important;
        }
        .wf-custom-tab-item {
          margin: 0 !important;
          padding: 0 !important;
        }
        .wf-custom-tab-link {
          background: transparent !important;
          border: 1px solid transparent !important;
          outline: none !important;
          box-shadow: none !important;
          padding: 7px 13px !important;
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #64748b !important;
          cursor: pointer !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          white-space: nowrap !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          position: relative !important;
          user-select: none !important;
          border-radius: 9px !important;
        }
        .wf-custom-tab-link:hover {
          color: #0f172a !important;
          background: rgba(255, 255, 255, 0.7) !important;
        }
        .wf-custom-tab-link.active {
          color: #1d4ed8 !important;
          font-weight: 800 !important;
          background: #ffffff !important;
          border-color: #e2e8f0 !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 2px 5px -2px rgba(15, 23, 42, 0.08) !important;
        }
        .wf-custom-tab-link.active:hover {
          background: #ffffff !important;
        }
        .wf-custom-tab-link:focus,
        .wf-custom-tab-link:active,
        .wf-custom-tab-link:focus-visible {
          outline: none !important;
          box-shadow: none !important;
        }
        .wf-custom-tab-link.active:focus,
        .wf-custom-tab-link.active:active {
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 2px 5px -2px rgba(15, 23, 42, 0.08) !important;
        }
        .wf-custom-tab-link i {
          font-size: 13px !important;
          transition: color 0.2s ease, opacity 0.2s ease !important;
          color: inherit !important;
          opacity: 0.75 !important;
        }
        .wf-custom-tab-link.active i {
          color: #1d4ed8 !important;
          opacity: 1 !important;
        }

        /* Responsive adjustments for Custom Tabs */
        @media (max-width: 768px) {
          .wf-custom-tabs-list {
            width: 100% !important;
            overflow-x: auto !important;
            flex-wrap: nowrap !important;
            padding: 4px !important;
          }
          .wf-custom-tab-link {
            padding: 7px 12px !important;
            font-size: 12.5px !important;
          }
        }

        .wf-tab-content-container {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          padding: 24px;
          margin-top: 12px;
        }

        .wf-tab-inner-header {
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
          padding: 12px 16px !important;
          background: #f8fafc !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 8px !important;
          margin-bottom: 20px !important;
        }
        .wf-tab-inner-icon {
          width: 32px !important;
          height: 32px !important;
          border-radius: 6px !important;
          background: #eff6ff !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #2563eb !important;
          font-size: 14px !important;
          flex-shrink: 0 !important;
        }
        .wf-tab-inner-text {
          display: flex !important;
          flex-direction: column !important;
          gap: 2px !important;
        }
        .wf-tab-inner-title {
          font-size: 13px !important;
          font-weight: 800 !important;
          color: #0f172a !important;
          margin: 0 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.5px !important;
        }
        .wf-tab-inner-sub {
          font-size: 12px !important;
          font-weight: 500 !important;
          color: #64748b !important;
          margin: 0 !important;
          line-height: 1.4 !important;
        }

        /* ── Form Footer ── */
        .as-form-footer {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 10px !important;
          flex-wrap: wrap !important;
          padding: 14px 22px !important;
          border-top: 1.5px solid #f1f5f9 !important;
          background: #ffffff !important;
        }

        /* Align entity navigation and content spacing with the application theme. */
        .wf-add-candidate-container .wf-custom-tabs-container {
          margin-bottom: 0 !important;
        }
        .wf-add-candidate-container .wf-custom-tabs-list {
          width: fit-content !important;
          padding: 4px !important;
          gap: 4px !important;
          background: #f8fafc !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
        }
        .wf-add-candidate-container .wf-custom-tab-link {
          height: 34px !important;
          min-height: 34px !important;
          padding: 0 16px !important;
          border: 0 !important;
          border-radius: 0 !important;
          color: #475569 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
        }
        .wf-add-candidate-container .wf-custom-tab-link i {
          color: currentColor !important;
          font-size: 14px !important;
          opacity: 1 !important;
        }
        .wf-add-candidate-container .wf-custom-tab-link:hover {
          color: #171717 !important;
          background: #f5f5f5 !important;
        }
        .wf-add-candidate-container .wf-custom-tab-link.active,
        .wf-add-candidate-container .wf-custom-tab-link.active:hover,
        .wf-add-candidate-container .wf-custom-tab-link.active:focus,
        .wf-add-candidate-container .wf-custom-tab-link.active:active {
          color: #ffffff !important;
          background: #171717 !important;
          box-shadow: 0 2px 6px rgba(15, 23, 42, 0.16) !important;
        }
        .wf-add-candidate-container .wf-tab-content-container {
          margin-top: 10px !important;
          padding: 14px !important;
          border-radius: 0 !important;
        }
        .wf-add-candidate-container .wf-tab-content-container > .wf-subcontractor-tab-container,
        .wf-add-candidate-container .wf-tab-content-container > .wf-recruiter-tab-container {
          padding-left: 0 !important;
          padding-right: 0 !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container > .row,
        .wf-add-candidate-container .wf-recruiter-tab-container > .row {
          margin-left: -7px !important;
          margin-right: -7px !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container > .row > *,
        .wf-add-candidate-container .wf-recruiter-tab-container > .row > * {
          padding-left: 7px !important;
          padding-right: 7px !important;
        }
        .wf-add-candidate-container .wf-tab-inner-header {
          margin-bottom: 14px !important;
          border-radius: 0 !important;
        }
        .wf-add-candidate-container .wf-tab-inner-icon {
          color: #525252 !important;
          background: #f5f5f5 !important;
          border: 1px solid #d4d4d4 !important;
          border-radius: 0 !important;
        }
        @media (max-width: 768px) {
          .wf-add-candidate-container .wf-custom-tabs-list {
            width: 100% !important;
            overflow-x: auto !important;
            flex-wrap: nowrap !important;
          }
        }

        /* Keep all Add Candidate fields and actions square across entity forms. */
        .wf-add-candidate-container .as-form-body .form-control,
        .wf-add-candidate-container .wf-tab-content-container .form-control,
        .wf-add-candidate-container .wf-tab-content-container input:not([type="checkbox"]):not([type="radio"]),
        .wf-add-candidate-container .wf-tab-content-container select,
        .wf-add-candidate-container .wf-tab-content-container textarea,
        .wf-add-candidate-container .wf-tab-content-container button,
        .wf-add-candidate-container .wf-tab-content-container .btn,
        .wf-add-candidate-container .wf-tab-content-container .btn-primary-custom,
        .wf-add-candidate-container .wf-tab-content-container .btn-outline-primary-custom,
        .wf-add-candidate-container .wf-tab-content-container .btn-outline-info-custom,
        .wf-add-candidate-container .wf-tab-content-container .wf-merged-phone-wrapper,
        .wf-add-candidate-container .wf-tab-content-container .wf-cc-trigger,
        .wf-add-candidate-container .wf-tab-content-container .wf-phone-input,
        .wf-add-candidate-container .wf-tab-content-container .input-group,
        .wf-add-candidate-container .wf-tab-content-container .input-group-text {
          border-radius: 0 !important;
        }
        .wf-add-candidate-container .wf-tab-content-container .MuiOutlinedInput-root,
        .wf-add-candidate-container .wf-tab-content-container .MuiInputBase-root,
        .wf-add-candidate-container .wf-tab-content-container .MuiOutlinedInput-notchedOutline,
        .wf-add-candidate-container .wf-tab-content-container .MuiIconButton-root {
          border-radius: 0 !important;
        }

        /* Candidate fields do not render left icons; remove the reserved icon space. */
        .wf-add-candidate-container .wf-tab-content-container
          .wf-candidate-form-wrapper .wf-input-wrap .form-control,
        .wf-add-candidate-container .wf-tab-content-container
          .wf-candidate-form-wrapper .wf-input-wrap textarea.form-control {
          padding-left: 13px !important;
        }

        /* Match AddWorkflowPerformer typography across all entity forms. */
        .wf-add-candidate-container,
        .wf-add-candidate-container .as-form-body,
        .wf-add-candidate-container .wf-tab-content-container {
          font-family: "Open Sans", sans-serif !important;
        }
        .wf-add-candidate-container .as-form-body .wf-control-label,
        .wf-add-candidate-container .wf-tab-content-container .wf-control-label,
        .wf-add-candidate-container .wf-tab-content-container .form-control-label,
        .wf-add-candidate-container .wf-tab-content-container .form-group > label {
          font-family: inherit !important;
          font-size: 11px !important;
          font-weight: 600 !important;
          letter-spacing: 0.7px !important;
        }
        .wf-add-candidate-container .as-form-body .form-control,
        .wf-add-candidate-container .wf-tab-content-container .form-control,
        .wf-add-candidate-container .wf-tab-content-container input,
        .wf-add-candidate-container .wf-tab-content-container select,
        .wf-add-candidate-container .wf-tab-content-container textarea,
        .wf-add-candidate-container .wf-tab-content-container .MuiOutlinedInput-input {
          font-family: inherit !important;
          font-size: 13.5px !important;
          font-weight: 400 !important;
        }
        .wf-add-candidate-container .wf-tab-content-container input::placeholder,
        .wf-add-candidate-container .wf-tab-content-container textarea::placeholder,
        .wf-add-candidate-container .wf-tab-content-container .MuiOutlinedInput-input::placeholder {
          font-family: inherit !important;
          font-size: 13.5px !important;
          font-weight: 400 !important;
        }
        .wf-add-candidate-container .wf-tab-content-container .wf-candidate-form-wrapper .btn,
        .wf-add-candidate-container .wf-tab-content-container .btn-primary-custom,
        .wf-add-candidate-container .wf-tab-content-container .btn-outline-primary-custom,
        .wf-add-candidate-container .wf-tab-content-container .btn-outline-info-custom {
          font-family: inherit !important;
          font-size: 14px !important;
          font-weight: 500 !important;
        }
        .wf-add-candidate-container .wf-tab-inner-title {
          font-family: inherit !important;
          font-size: 11px !important;
          font-weight: 600 !important;
          letter-spacing: 0.7px !important;
        }
        .wf-add-candidate-container .wf-tab-inner-sub {
          font-family: inherit !important;
          font-size: 12px !important;
          font-weight: 400 !important;
        }

        /* Keep Subcontractor and Recruiter actions on the black-and-white theme. */
        .wf-add-candidate-container .wf-subcontractor-tab-container .btn-outline-primary-custom,
        .wf-add-candidate-container .wf-subcontractor-tab-container .btn-outline-info-custom,
        .wf-add-candidate-container .wf-recruiter-tab-container .btn-outline-primary-custom,
        .wf-add-candidate-container .wf-recruiter-tab-container .btn-outline-info-custom {
          color: #1e293b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .btn-outline-primary-custom:hover,
        .wf-add-candidate-container .wf-subcontractor-tab-container .btn-outline-info-custom:hover,
        .wf-add-candidate-container .wf-recruiter-tab-container .btn-outline-primary-custom:hover,
        .wf-add-candidate-container .wf-recruiter-tab-container .btn-outline-info-custom:hover {
          color: #ffffff !important;
          background: #171717 !important;
          border-color: #171717 !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.14) !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-info-banner,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-info-banner {
          color: #1e293b !important;
          background: #f8fafc !important;
          border: 0 !important;
          border-left: 4px solid #171717 !important;
          border-radius: 0 !important;
          gap: 8px !important;
          box-shadow: none !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-info-banner-icon,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-info-banner-icon {
          margin: 0 !important;
          flex: 0 0 auto !important;
          font-family: FontAwesome !important;
          line-height: 1 !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-info-banner-icon,
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-info-banner-text,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-info-banner-icon,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-info-banner-text {
          color: #1e293b !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .btn-primary-custom,
        .wf-add-candidate-container .wf-recruiter-tab-container .btn-primary-custom {
          color: #ffffff !important;
          background: #171717 !important;
          border-color: #171717 !important;
          box-shadow: 0 2px 6px rgba(15, 23, 42, 0.16) !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .btn-primary-custom:hover:not(:disabled),
        .wf-add-candidate-container .wf-recruiter-tab-container .btn-primary-custom:hover:not(:disabled) {
          color: #ffffff !important;
          background: #000000 !important;
          border-color: #000000 !important;
          box-shadow: 0 4px 10px rgba(15, 23, 42, 0.2) !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-save-assignment-btn,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-save-assignment-btn {
          color: #ffffff !important;
          background: #2563eb !important;
          border-color: #2563eb !important;
          box-shadow: 0 2px 6px rgba(37, 99, 235, 0.2) !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-save-assignment-btn:hover:not(:disabled),
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-save-assignment-btn:hover:not(:disabled) {
          color: #ffffff !important;
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          box-shadow: 0 4px 10px rgba(37, 99, 235, 0.24) !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-save-assignment-btn:disabled,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-save-assignment-btn:disabled {
          color: #94a3b8 !important;
          background: #e2e8f0 !important;
          border-color: #cbd5e1 !important;
          box-shadow: none !important;
          cursor: not-allowed !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .form-control:focus,
        .wf-add-candidate-container .wf-recruiter-tab-container .form-control:focus {
          border-color: #171717 !important;
          background-color: #ffffff !important;
          box-shadow: 0 0 0 3px rgba(15, 23, 42, 0.08) !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-input-wrap:focus-within .wf-input-icon,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-input-wrap:focus-within .wf-input-icon,
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-detail-table-card i,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-detail-table-card i {
          color: #1e293b !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-input-wrap .wf-input-icon,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-input-wrap .wf-input-icon {
          display: none !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-input-wrap .form-control:not(textarea),
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-input-wrap .form-control:not(textarea) {
          height: 38px !important;
          min-height: 38px !important;
          padding-left: 12px !important;
          padding-right: 12px !important;
          line-height: normal !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container textarea.form-control,
        .wf-add-candidate-container .wf-recruiter-tab-container textarea.form-control,
        .wf-add-candidate-container .wf-agency-tab-container textarea.form-control,
        .wf-add-candidate-container .wf-msp-tab-container textarea.form-control {
          width: 100% !important;
          min-height: 80px !important;
          padding: 12px 14px !important;
          line-height: 1.5 !important;
          resize: vertical !important;
          overflow: auto !important;
          border-radius: 0 !important;
          box-sizing: border-box !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-input-wrap select.form-control,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-input-wrap select.form-control {
          padding-right: 32px !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-input-wrap .form-control::placeholder,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-input-wrap .form-control::placeholder {
          color: #94a3b8 !important;
          opacity: 1 !important;
        }

        /* Enhanced, square Subcontractor details section. */
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-detail-table-card,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-detail-table-card {
          margin-top: 12px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          box-shadow: 0 2px 7px rgba(15, 23, 42, 0.08) !important;
          overflow: hidden !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-detail-table-card .table-responsive,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-detail-table-card .table-responsive {
          border: 0 !important;
          outline: 0 !important;
          box-shadow: none !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-detail-table,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-detail-table {
          margin: 0 !important;
          border: 0 !important;
          outline: 0 !important;
          box-shadow: none !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-detail-table-card .card-header,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-detail-table-card .card-header {
          min-height: 42px !important;
          padding: 0 14px !important;
          display: flex !important;
          align-items: center !important;
          background: #f8fafc !important;
          border-bottom: 1px solid #cbd5e1 !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-detail-table-card .card-header h4,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-detail-table-card .card-header h4 {
          color: #1e293b !important;
          font-family: inherit !important;
          font-size: 13px !important;
          font-weight: 600 !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-detail-table-card .card-header i,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-detail-table-card .card-header i {
          color: #1e293b !important;
          font-family: FontAwesome !important;
          font-size: 13px !important;
          font-weight: normal !important;
          line-height: 1 !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-detail-table td,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-detail-table td {
          padding: 10px 14px !important;
          border-right: 1px solid #e2e8f0 !important;
          border-bottom: 1px solid #e2e8f0 !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-detail-table tr:last-child td,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-detail-table tr:last-child td {
          border-bottom: 0 !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-detail-table td:last-child,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-detail-table td:last-child {
          border-right: 0 !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-detail-table td.wf-detail-label,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-detail-table td.wf-detail-label {
          color: #475569 !important;
          background: #f8fafc !important;
          font-weight: 600 !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-detail-table td.wf-detail-value,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-detail-table td.wf-detail-value {
          color: #1e293b !important;
          background: #ffffff !important;
          font-weight: 500 !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-detail-table tr:hover td.wf-detail-value,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-detail-table tr:hover td.wf-detail-value {
          background: #fafafa !important;
        }

        /* Agency/MSP fields use plain labels and controls without decorative icons. */
        .wf-add-candidate-container .wf-agency-tab-container .form-group label > i,
        .wf-add-candidate-container .wf-msp-tab-container .form-group label > i,
        .wf-add-candidate-container .wf-agency-tab-container .wf-section-title > i,
        .wf-add-candidate-container .wf-msp-tab-container .wf-section-title > i,
        .wf-add-candidate-container .wf-agency-tab-container .wf-input-icon,
        .wf-add-candidate-container .wf-msp-tab-container .wf-input-icon {
          display: none !important;
        }
        .wf-add-candidate-container .wf-agency-tab-container .form-group label,
        .wf-add-candidate-container .wf-msp-tab-container .form-group label,
        .wf-add-candidate-container .wf-agency-tab-container .wf-section-title,
        .wf-add-candidate-container .wf-msp-tab-container .wf-section-title {
          gap: 0 !important;
        }
        .wf-add-candidate-container .wf-agency-tab-container .form-control.wf-input-withicon,
        .wf-add-candidate-container .wf-msp-tab-container .form-control.wf-input-withicon,
        .wf-add-candidate-container .wf-agency-tab-container input.form-control.wf-input-withicon,
        .wf-add-candidate-container .wf-msp-tab-container input.form-control.wf-input-withicon,
        .wf-add-candidate-container .wf-agency-tab-container textarea.form-control.wf-input-withicon,
        .wf-add-candidate-container .wf-msp-tab-container textarea.form-control.wf-input-withicon {
          padding-left: 13px !important;
        }
        .wf-add-candidate-container .wf-agency-tab-container select.form-control.wf-input-withicon,
        .wf-add-candidate-container .wf-msp-tab-container select.form-control.wf-input-withicon {
          padding-left: 13px !important;
          padding-right: 32px !important;
        }
        .wf-add-candidate-container .wf-agency-tab-container .form-control::placeholder,
        .wf-add-candidate-container .wf-msp-tab-container .form-control::placeholder {
          color: #94a3b8 !important;
          opacity: 1 !important;
        }

        /* Match Candidate control borders across every related entity tab. */
        .wf-add-candidate-container .wf-subcontractor-tab-container .form-control,
        .wf-add-candidate-container .wf-recruiter-tab-container .form-control,
        .wf-add-candidate-container .wf-agency-tab-container .form-control,
        .wf-add-candidate-container .wf-msp-tab-container .form-control {
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          box-shadow: none !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .form-control:not(textarea),
        .wf-add-candidate-container .wf-recruiter-tab-container .form-control:not(textarea),
        .wf-add-candidate-container .wf-agency-tab-container .form-control:not(textarea),
        .wf-add-candidate-container .wf-msp-tab-container .form-control:not(textarea) {
          height: 38px !important;
          min-height: 38px !important;
          max-height: 38px !important;
          box-sizing: border-box !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .form-control:focus,
        .wf-add-candidate-container .wf-recruiter-tab-container .form-control:focus,
        .wf-add-candidate-container .wf-agency-tab-container .form-control:focus,
        .wf-add-candidate-container .wf-msp-tab-container .form-control:focus {
          border-color: #2563eb !important;
          background: #ffffff !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12) !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .form-control:disabled,
        .wf-add-candidate-container .wf-subcontractor-tab-container .form-control[disabled],
        .wf-add-candidate-container .wf-recruiter-tab-container .form-control:disabled,
        .wf-add-candidate-container .wf-recruiter-tab-container .form-control[disabled],
        .wf-add-candidate-container .wf-agency-tab-container .form-control:disabled,
        .wf-add-candidate-container .wf-agency-tab-container .form-control[disabled],
        .wf-add-candidate-container .wf-msp-tab-container .form-control:disabled,
        .wf-add-candidate-container .wf-msp-tab-container .form-control[disabled] {
          background: #f8fafc !important;
          border-color: #dbe3ee !important;
          color: #1e293b !important;
          opacity: 1 !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
        }
        .wf-add-candidate-container .wf-subcontractor-tab-container .wf-merged-phone-wrapper,
        .wf-add-candidate-container .wf-recruiter-tab-container .wf-merged-phone-wrapper,
        .wf-add-candidate-container .wf-agency-tab-container .wf-merged-phone-wrapper,
        .wf-add-candidate-container .wf-msp-tab-container .wf-merged-phone-wrapper {
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          box-shadow: none !important;
        }
        .wf-add-candidate-container .wf-agency-tab-container .wf-section-title,
        .wf-add-candidate-container .wf-msp-tab-container .wf-section-title {
          border-left: 4px solid #171717 !important;
          border-radius: 0 !important;
        }
      `}</style>

      <div className="wf-add-candidate-container">
        {/* ── Form Header ── */}
        <div className="as-form-header">
          <div className="as-form-header-left">
            {actionType === "edit" && selectedObj?.performerid ? (
              <>
                <div className="as-form-header-icon">
                  <i className="fa fa-pencil-square-o" />
                </div>
                <div className="as-form-header-text">
                  <p className="as-form-header-title">Edit Candidate Details</p>
                  <div className="as-selected-context-details">
                    <span>ID: #{selectedObj.performerid}</span>
                    {selectedObj.maxloans && (
                      <>
                        <span className="as-selected-context-separator">&bull;</span>
                        <span>IPCS: #{selectedObj.maxloans}</span>
                      </>
                    )}
                    {selectedObj.performeremail && (
                      <>
                        <span className="as-selected-context-separator">&bull;</span>
                        <span>{selectedObj.performeremail}</span>
                      </>
                    )}
                    {selectedObj.contactNo && (
                      <>
                        <span className="as-selected-context-separator">&bull;</span>
                        <span>{getFormatedNumber(selectedObj.contactNo)}</span>
                      </>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="as-form-header-icon">
                  <i className="fa fa-user-plus" />
                </div>
                <div className="as-form-header-text">
                  <p className="as-form-header-title">Add New Candidate Partner</p>
                </div>
              </>
            )}
          </div>
          <div className="as-form-header-right">
            <button
              type="button"
              className="as-header-back-btn"
              onClick={handleBackToCandidateList}
            >
              <i className="fa fa-arrow-left" aria-hidden="true" />
              Back
            </button>
          </div>
        </div>

        {/* ── Form Body ── */}
        <div className="as-form-body">
          <div className="row">
            <div className="col-lg-12 form-group mb-0">
              <label htmlFor="CandidateEntity" className="wf-control-label">
                Candidate Entity
              </label>
              <div className="wf-input-wrap wf-input-wrap-no-icon">
                <select
                  name="CandidateEntity"
                  id="CandidateEntity"
                  className="form-control wf-input wf-select wf-dropdown-no-icon"
                  onChange={handleSelectEntity}
                  value={entityType}
                  disabled={actType === "edit"}
                >
                  <option value="">Select Candidate Entity</option>
                  {candidateEntity.map((item) => (
                    <option key={item.id} value={item.name}>{item.name}</option>
                  ))}
                </select>
              </div>
            </div>

            {entityType === "W2 Basis" && (
              <div className="col-md-12 form-group mb-3">
                <label htmlFor="w9_Type" className="wf-control-label">
                  Select Benefits
                </label>
                <div className="wf-input-wrap wf-input-wrap-no-icon">
                  <select
                    name="w9_Type"
                    id="w9_Type"
                    className="form-control wf-input wf-select wf-dropdown-no-icon"
                    onChange={({ currentTarget }) => setW2type(currentTarget.value)}
                    value={w2Type}
                  >
                    <option value="">Select Benefits</option>
                    {w2Basis.map((item) => (
                      <option key={item.id} value={item.name}>{item.name}</option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            {entityType && (
              <div className="col-md-12 mt-3">
                <div className="wf-custom-tabs-container">
                  <div className="wf-custom-tabs-list">
                    {activeTabs.map((tab) => (
                      <button
                        key={tab.key}
                        type="button"
                        className={`wf-custom-tab-link${selectedKey === tab.key ? " active" : ""}`}
                        onClick={() => setKey(tab.key)}
                      >
                        <i className={`fa ${tab.icon}`} aria-hidden="true" />
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="wf-tab-content-container">
                  {selectedKey === "0" && (
                    <Candidate
                      updateSelectedObject={updateSelectedObject}
                      candidateObj={candidateObj}
                      handleNextTab={handleNextTab}
                      entityType={entityType}
                      w2Type={w2Type}
                      wfId={wfId}
                      wfTask={wfTask}
                      wfForm={wfForm}
                      actionType={actionType}
                      actType={actType}
                      rateHistory={rateHistory}
                      disabledFieldIds={actType === "edit" ? ["candidateonboardingform.IPCS_Existing_ID", "IPCS_Existing_ID"] : []}
                    />
                  )}

                  {selectedKey === "1" && entityType === "C2C Basis" && (
                    <Subcontractor
                      candidateObj={candidateObj}
                      entityType={entityType}
                      handleNextTab={handleNextTab}
                      updateSelectedObject={updateSelectedObject}
                      actType={actType}
                      rateHistory={rateHistory}
                    />
                  )}

                  {selectedKey === "2" && (
                    <Recruiter
                      candidateObj={candidateObj}
                      handleNextTab={handleNextTab}
                      updateSelectedObject={updateSelectedObject}
                      actType={actType}
                      rateHistory={rateHistory}
                    />
                  )}

                  {selectedKey === "3" && (
                    <Agency
                      candidateObj={candidateObj}
                      handleNextTab={handleNextTab}
                      updateSelectedObject={updateSelectedObject}
                      actType={actType}
                      rateHistory={rateHistory}
                    />
                  )}

                  {selectedKey === "4" && (
                    <Msp
                      candidateObj={candidateObj}
                      updateSelectedObject={updateSelectedObject}
                      actType={actType}
                      setSelectedTabKey={setSelectedTabKey}
                      setSelectedCandidateId={setSelectedCandidateId}
                      handleNextTab={handleNextTab}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* ── Form Footer ── */}
      </div>
    </>
  );
};

export default AddCandidate;
